<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.2926 8.29305C17.4812 8.11089 17.7338 8.0101 17.996 8.01238C18.2582 8.01466 18.509 8.11982 18.6944 8.30523C18.8798 8.49064 18.985 8.74145 18.9873 9.00365C18.9895 9.26585 18.8888 9.51845 18.7066 9.70705L12.7066 15.7071C12.5244 15.8893 12.2788 15.9942 12.0211 15.9998C11.7634 16.0054 11.5136 15.9112 11.3236 15.7371L5.32359 10.2371C5.2233 10.1493 5.14157 10.0424 5.08319 9.92259C5.0248 9.8028 4.99095 9.67255 4.98362 9.53949C4.97629 9.40643 4.99563 9.27325 5.0405 9.14777C5.08537 9.02229 5.15487 8.90704 5.24491 8.8088C5.33496 8.71057 5.44372 8.63131 5.56483 8.57571C5.68593 8.5201 5.81693 8.48926 5.95012 8.485C6.08331 8.48073 6.21602 8.50314 6.34043 8.55089C6.46484 8.59864 6.57845 8.67077 6.67459 8.76305L11.9696 13.6161L17.2926 8.29305Z"
      :fill="color"
    />
  </svg>
</template>
<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
